import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import * as React from "react";
import { connect } from "react-redux";
import { titleColor } from "../../config/ColorObj";
import endpoint from "../../config/endpoints";
import { noInternetMsg, serverMsg } from "../../config/messageconstant";
import { imageUrl } from "../../config/Url";
import { apiGet } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { classes, children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const FeedbackImage = ({
  handleCloses,
  open,
  showLoador,
  showNotification,
  columns,
  rows,
  id,
  itemObject,
  outletOrderHeaderId,
}) => {
  const [dataToSet, setDataToSet] = React.useState([]);
  const [popUpOpenFlag, setPopUpOpenFlag] = React.useState(false);
  const [image, setImage] = React.useState("");
  const [imageLoaded, setImageLoaded] = React.useState(false);
  const [googleApiKey, setGoogleApiKey] = React.useState(
    "AIzaSyDvKXkZ-S03qxR-8b8HLnCOKr36eYRxC2k"
  );
  const [address, setAddress] = React.useState("");

  const handleClose = () => {
    handleCloses();
  };

  React.useEffect(() => {
    apiMethod();
  }, [
    open,
    id,
    itemObject.date,
    itemObject.outletOrderHeaderId,
    // itemObject.workType,
    // itemObject.workingTypeId,
  ]);

  const apiMethod = async () => {
    if (navigator.onLine) {
      let dataJson = {};

      showLoador({ loador: true });
      await apiGet({
        url: endpoint.grievance + "/" + outletOrderHeaderId,
      }).then(({ data, success }) => {
        showLoador({ loador: false });

        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        } else {
          const responseData = data.data;
          if (responseData && responseData.length !== 0) {
            const imageData = responseData.docPic;
            setImage(imageData || "");
            dataJson = {
              outlet: responseData?.outLet?.firmName || "-",
              grivienceCategory:
                responseData?.grivienceCategory?.categoryName || "-",
              insertDateTime: responseData?.insertDateTime || "-",
              remark: responseData?.remark || "-",
            };
            setDataToSet(dataJson);
          } else {
            showNotification({
              msg: "No feedback data found",
              severity: "error",
            });
          }
          setAddressData();
        }
      });

      popUpFlagMethod();
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };
  const setAddressData = () => {
    if (googleApiKey !== null) {
      if (itemObject?.managerStartLat && itemObject?.managerStartLong) {
        showLoador({ loador: true });
        const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${itemObject.managerStartLat},${itemObject.managerStartLong}&key=${googleApiKey}`;

        fetch(apiUrl)
          .then((response) => response.json())
          .then((data) => {
            showLoador({ loador: false });

            if (data.status === "OK" && data.results.length !== 0) {
              const fetchedAddress = data.results[0].formatted_address;
              setAddress(fetchedAddress);
            } else {
              console.error("Error:", data.status);
            }
          })
          .catch((error) => {
            showLoador({ loador: false });
            console.error("Error:", error);
          });
      }
    }
  };

  const popUpFlagMethod = () => {
    setPopUpOpenFlag(true);
  };

  return (
    <>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={popUpOpenFlag}
        fullWidth
        maxWidth="md"
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
        >
          Feedback Details{" "}
        </BootstrapDialogTitle>

        <DialogContent
          style={{ display: "flex", overflowX: "hidden", width: "100%" }}
          dividers
        >
          <div
            style={{
              width: "70%",
            }}
          >
            {itemObject.workType == 1 && itemObject.workingTypeId == 4 && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: "20px",
                }}
              >
                <div
                  style={{
                    color: titleColor,
                    marginRight: "10px",
                    width: "25%",
                  }}
                >
                  {"Outlet Name :"}
                </div>
                <div>{dataToSet.outlet}</div>
              </div>
            )}
            {((itemObject.workType === 2 && itemObject.workingTypeId === 4) ||
              (itemObject.workType === 11 &&
                itemObject.workingTypeId === 4)) && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginBottom: "20px",
                }}
              >
                <div
                  style={{
                    color: titleColor,
                    marginRight: "10px",
                    width: "25%",
                  }}
                >
                  {"Date and Time :"}
                </div>
                <div>
                  {dataToSet.insertDateTime ? dataToSet.insertDateTime : "-"}
                </div>
              </div>
            )}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: "20px",
              }}
            >
              <div
                style={{
                  color: titleColor,
                  marginRight: "10px",
                  width: "25%",
                }}
              >
                {"Category :"}
              </div>
              <div>
                {dataToSet.grivienceCategory
                  ? dataToSet.grivienceCategory
                  : "-"}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: "20px",
              }}
            >
              <div
                style={{
                  color: titleColor,
                  marginRight: "10px",
                  width: "25%",
                }}
              >
                {"Remark :"}
              </div>
              <div>{dataToSet.remark ? dataToSet.remark : "-"}</div>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "right",
              alignItems: "right",
              height: "100%",
              textAlign: "right",
            }}
          >
            {image && (
              <img
                src={imageUrl + image}
                onLoad={() => setImageLoaded(true)}
                style={{
                  display: imageLoaded ? "block" : "none",
                  width: "250px",
                  height: "380px",
                }}
              />
            )}
            {!imageLoaded && (
              <div
                style={{
                  width: "250px",
                  height: "380px",
                  backgroundColor: "#f0f0f0",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span>Loading image...</span>
              </div>
            )}
          </div>
        </DialogContent>
      </BootstrapDialog>
    </>
  );
};
const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
  showLoador,
  showNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackImage);
